import * as React from 'react';
import { find } from 'lodash';
import { setSort } from '../../actions/index';
import { ISort } from '../../state-helpers/sorts';
import { IAnalytics } from '../../../global/functions/analytics';
import { IEpiProps } from '../../state-helpers/epi-props';
import { addUrlProps, UrlQueryParamTypes } from 'react-url-query';
import { connect } from 'react-redux';
import { findDOMNode } from 'react-dom';

export interface IAdvancedSearchMenuProps {
    epiProps: IEpiProps;
    onCloseClick: () => void;
    analytics: IAnalytics;
}

export class AdvancedSearchMenu extends React.Component<IAdvancedSearchMenuProps, any> {
 
    componentWillMount() {
        document.addEventListener('click', this.handleOutsideClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick, false);
    }

    handleOutsideClick = (e) => {
        if (e.target.id === 'advanced-search-menu-wrapper') {
            this.props.onCloseClick();
        }
    }

    onAdvancedSearchClick = () => {
        this.props.analytics.onLinkClick();
        window.location.href = this.props.epiProps.advancedMenuLinkUrl;
    }

    render() {

        return (
            <div id="advanced-search-menu-wrapper" className="advanced-search-menu-wrapper" style={{ display: 'block' }}>
                <div className="dialog">
                    <div className="advanced-search-menu-container" >
                        <h5 className="advanced-search-menu-title" dangerouslySetInnerHTML={{ __html: this.props.epiProps.advancedMenuTitleText }} />
                        <div className="advanced-search-menu-link-container">
                            <p className="advanced-search-menu-prompt-button" dangerouslySetInnerHTML={{ __html: this.props.epiProps.advancedMenuPromptQueryBuilderText }} />
                            <a onClick={this.onAdvancedSearchClick} className="button-primary advanced-search-menu-button">{this.props.epiProps.advancedMenuLinkText}</a>
                        </div>
                        <p className="advanced-search-menu-prompt" dangerouslySetInnerHTML={{ __html: this.props.epiProps.advancedMenuPromptText }} />
                        <div className="advanced-search-menu-list">
                            <ul>
                                <li className="advanced-search-menu-text" dangerouslySetInnerHTML={{ __html: this.props.epiProps.advancedMenuANDText }} />
                                <li className="advanced-search-menu-text" dangerouslySetInnerHTML={{ __html: this.props.epiProps.advancedMenuORText }} />
                                <li className="advanced-search-menu-text" dangerouslySetInnerHTML={{ __html: this.props.epiProps.advancedMenuNOTText }} />
                                <li className="advanced-search-menu-text" dangerouslySetInnerHTML={{ __html: this.props.epiProps.advancedMenuQuotesText }} />
                            </ul>
                        </div>
                    </div>
                    <div className="dialog-action">
                        <a className="advanced-search-menu-button" id="advanced-search-keywords-close" onClick={this.props.onCloseClick}>Got It</a>
                    </div>
                </div >
            </div>
        )
    }


};
